import React from 'react';
// import { NavLink } from 'react-router-dom';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';

const projects = [
    {
        image: require('./../../images/machineries/1.CP-18.webp'),
        title: 'Concrete Batching Plant CP-18',
        address: '',
        filter: 'col-one'
    },
    {
        image: require('./../../images/machineries/2.Stationery-Concrete-Pump.webp'),
        title: 'Stationery Concrete Pump',
        address: 'AQUIRUS/SCHWING',
        filter: 'col-two'
    },
    {
        image: require('./../../images/machineries/3.Cutting-Machines.webp'),
        title: 'Cutting Machine',
        address: 'SPARTAN/JAYPEE',
        filter: 'col-three'
    },
    {
        image: require('./../../images/machineries/4.Bending-Machine.webp'),
        title: 'Bending Machine',
        address: 'SPARTAN/JAYPEE',
        filter: 'col-four'
    },
    {
        image: require('./../../images/machineries/5.Multi-Functional-Hoist.webp'),
        title: 'Multi Functional Hoist',
        address: 'SPARTAN/JAYPEE',
        filter: 'col-three'
    },
    {
        image: require('./../../images/machineries/6.Tower-Crane.webp'),
        title: 'Tower Crane',
        address: 'ACE',
        filter: 'col-two'
    },
    {
        image: require('./../../images/machineries/7.Passenger-Hoist.webp'),
        title: 'Passenger Hoist',
        address: '',
        filter: 'col-one'
    },
    {
        image: require('./../../images/machineries/8.Dewatering-Pump.webp'),
        title: 'Dewatering Pump - 5 HP/ 3 HP',
        address: '',
        filter: 'col-one'
    },
    {
        image: require('./../../images/machineries/9.Curing-Pump-BE-Equivalent.webp'),
        title: 'Curing Pump - BE / Equivalent',
        address: '',
        filter: 'col-two'
    },
    {
        image: require('./../../images/machineries/10.Slab-Shuttering-Arrangement.webp'),
        title: 'Slab Shuttering Arrangement',
        address: 'Conventional Shuttering System with MS Prop & Span & Cup Lock System',
        filter: 'col-three'
    },
    {
        image: require('./../../images/machineries/11.Plate-Compactor.webp'),
        title: 'Plate Compactor',
        address: '',
        filter: 'col-four'
    },
    {
        image: require('./../../images/machineries/12.Welding-Rectifier.webp'),
        title: 'Welding Rectifier',
        address: '',
        filter: 'col-three'
    },
    {
        image: require('./../../images/machineries/13.QC-Lab.webp'),
        title: 'QC Lab',
        address: '',
        filter: 'col-two'
    },
    {
        image: require('./../../images/machineries/14.Cube-Testing-Machine-2000-KN.webp'),
        title: 'Cube Testing Machine 2000 KN',
        address: '',
        filter: 'col-one'
    },
    {
        image: require('./../../images/machineries/15.Cube-Moulds.webp'),
        title: 'Cube Moulds',
        address: '',
        filter: 'col-one'
    },
    {
        image: require('./../../images/machineries/16.Sieve-Set-for-Fine-Aggregate.webp'),
        title: 'Sieve set for Fine Aggregate',
        address: '',
        filter: 'col-two'
    },
    {
        image: require('./../../images/machineries/17.L-Box.webp'),
        title: 'L-Box',
        address: '',
        filter: 'col-three'
    },
    {
        image: require('./../../images/machineries/18.V-Funnel.webp'),
        title: 'V-Funnel',
        address: '',
        filter: 'col-four'
    },
    {
        image: require('./../../images/machineries/19.Flow-Table.webp'),
        title: 'Flow Table',
        address: '',
        filter: 'col-three'
    },
    {
        image: require('./../../images/machineries/20.Total-Station.webp'),
        title: 'Total Station',
        address: '',
        filter: 'col-two'
    },
    {
        image: require('./../../images/machineries/21.Auto-Level.webp'),
        title: 'Auto Level',
        address: '',
        filter: 'col-one'
    }
]

// var bgimg1 = require('./../../images/background/cross-line2.png');
var bgimg1 = require('./../../images/background/bg-5.png');

class Machineries extends React.Component {
    componentDidMount() {
        function loadScript(src) {

            return new Promise(function (resolve, reject) {
                var script = document.createElement('script');
                script.src = src;
                script.addEventListener('load', function () {
                    resolve();
                });
                script.addEventListener('error', function (e) {
                    reject(e);
                });
                document.body.appendChild(script);
                document.body.removeChild(script);
            })
        };

        loadScript('./assets/js/custom.js');

    };
    render() {
        const options = {
            loop:true,
            autoplay:false,
            center: false,
            items:3,
            margin:40,
            nav:true,
            dots: false,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive:{
                0:{
                    items:1,
                    margin:15
                },
                640:{
                    items:2,
                    margin:15
                },			
                800:{
                    items:3,
                    margin:20,
                },
                1200:{
                    items:4
                }			
                
            }
        };
        return (
            <>
                <div className="section-full p-tb80 bg-white inner-page-padding" style={{ backgroundImage: 'url(' + bgimg1 + ')' }}>
                    <div className="container-fluid">
                        <div className="section-content">
                            <div className="work-carousel-outer">
                                <div className="sx-box">
                                    <h3 className="m-t0 m-b30">List of <span className="sx-text-primary"> Machineries</span></h3>
                                </div>
                                <OwlCarousel className="owl-carousel mfp-gallery project-carousel project-carousel4 owl-btn-vertical-center" {...options}>
                                    {projects.map((item, index) => (
                                        <div key={index} className={`${item.filter} item fadingcol overflow-hide`}>
                                            <div className="sx-box image-hover-block">
                                                <div className="sx-thum-bx">
                                                    <img src={item.image} alt="" />
                                                </div>
                                                <div className="sx-info  p-t20 text-white">
                                                    <h4 className="sx-tilte">{item.title}</h4>
                                                    <p className="m-b0">{item.address}</p>
                                                </div>
                                                <a className="mfp-link" href={item.image}>
                                                    <i className="fa fa-arrows-alt" />
                                                </a>
                                            </div>
                                        </div>
                                    ))}
                                </OwlCarousel>

                            </div>
                        </div>
                    </div>
                </div>

            </>
        );
    }
};

export default Machineries;